import { useEffect } from "react";
import { getLogRocketHeaders } from "./services/LogRocketService";
import fetchRetry from 'fetch-retry';

/**
* Calls an API endpoint, handling errors
* - Converts non-200 statuses into errors
* - Adds context to errors
* - Retries on network failure
*/
export const handleRequest = async (
    method,
    url,
    failureMessage,
    body = null,
    retry = true) => {
  try {
    let params = { method, headers: getLogRocketHeaders() };
    if (body) {
      params = {
        ...params,
        headers: { ...params.headers, "Accept": "application/json", "Content-Type": "application/json" },
        body: JSON.stringify(body)
      } 
    };

    const fetch = retry ? fetchRetry(global.fetch) : global.fetch;
    const res = await fetch(url, params);
    
    if (!res.ok) {
      const resBody = await res.json();
      const errorText = resBody.message || resBody.error || "Error Unknown";
      throw new Error(`${errorText} (Error: ${res.status})`);
    }

    return await res.json();
  } catch (err) {
    console.error(`Failed to fetch resource from ${url}: ${err.message}`);
    throw new Error(`${failureMessage}. ${err.message}`);
  }
};

export const getEntryComponentValue = (entry, entryComponentKey) => {
  return entry.entryComponents
    .filter(ec => ec.key === entryComponentKey)
    .map(ec => ec.value)[0];
}

export const hasEntryComponentValue = (entry, entryComponentKey) => {
  return entry.entryComponents
    .filter(ec => ec.key === entryComponentKey)
    .map(ec => ec.value).length > 0;
}

export const getUrlParam = (name) => {
  var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
  if (results)
    return results[1] || "";
  return "";
}

export const useAsync = (asyncFn, onSuccess, deps = []) => {
  useEffect(() => {
    let isActive = true;
    asyncFn().then(data => {
      if (isActive) onSuccess(data);
    });
    return () => { isActive = false };
  }, deps);
}

// This is the equivalent of the jquery $.params function
export const params = (obj) => {
  return Object.keys(obj).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(obj[k])).join('&');
}
